<template>
  <unauthenticated-layout>
    <div id="not-found-content">
      <b-col md="4" offset-md="4" class="text-center">
        <div class="index-card">
          <h1 class="content-title">404 | Not Found</h1>
          <p>The page you requested could not be found.</p>
          <p>
            <b-link to="/">Go Home</b-link>
          </p>
        </div>
      </b-col>
    </div>
  </unauthenticated-layout>
</template>

<script>
import UnauthenticatedLayout from "../layouts/UnauthenticatedLayout";

export default {
  components: { UnauthenticatedLayout },
};
</script>
